import * as requestFromServer from './donaturCrud';
import { donaturSlice, callTypes } from './donaturSlice';
import { actions as auth } from '../../../Auth/_redux/authRedux'
import { toastOption } from '../../../../../_metronic/_helpers/ToastHelpers'
import { toast } from 'react-toastify'

const { actions } = donaturSlice;

export const fetchDonaturs = (queryParams) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer.findDonaturs(queryParams)
        .then(response => {
            const { data: { total_items, items } } = response.data;
            dispatch(actions.donatursFetched({ total_items, items }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const fetchDonatur = (id) => dispatch => {
    if (!id) {
        return dispatch(actions.donaturFetched({ donaturForEdit: undefined }));
    }

    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.getDonaturById(id)
        .then(response => {
            let { data: donatur } = response.data; // alias data -> donatur
            donatur.type = donatur.type ? donatur.type : 'INDIVIDU'
            dispatch(actions.donaturFetched({ donaturForEdit: donatur }));
            return donatur;
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const fetchChilds = (id) => dispatch => {
    if (!id) {
        return dispatch(actions.childsFetched({ listChild: undefined }));
    }

    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.getChilds(id)
        .then(response => {
            dispatch(actions.childsFetched({ childsFetched: response.data.data }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const fetchParents = (id) => dispatch => {
    if (!id) {
        return dispatch(actions.parentsFetched({ listParent: undefined }));
    }

    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.getParents(id)
        .then(response => {
            dispatch(actions.parentsFetched({ parentsFetched: response.data.data }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const fetchDonationHistory = (queryParams) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer.getDonationList(queryParams)
        .then(response => {
            const { data: { total_items, items } } = response.data;
            dispatch(actions.donationHistorysFetched({ total_items, items }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};



export const createDonatur = (donaturForCreation) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.createDonatur(donaturForCreation)
        .then(response => {
            dispatch(actions.donatursReload);
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
            return error
        });
};

export const updateDonatur = (donatur) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.updateDonatur(donatur)
        .then(response => {
            dispatch(actions.donatursReload);
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const changePasswordDonatur = (payload) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.changePasswordDonatur(payload)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
            return error
        });
};

export const migrateDonation = (payload) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.migrateDonation(payload)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
            return error
        });
};

export const importDonatur = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .importDonatur(payload)
    .then((response) => {
        dispatch(actions.donatursReload);
        toast.success(response.data.message, toastOption)
      return response.data;
    })
    .catch((error) => {
        let err = error
        if (error.response.status === 401) {
            toast.error(error.response.data.message, toastOption);
            dispatch(auth.logout());
        }
        error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      return err;
    });
};

export const validationImportDonatur = payload => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
    .validationImportDonatur(payload)
    .then(response => {
        dispatch(actions.donatursReload);
        return response.data;
    })
    .catch(error => {
        let err = error;
        if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
        }
        error = error.response.data.message;
        dispatch(
        actions.catchError({ error, callType: callTypes.action })
        );
        return err;
    });
};

export const createImportDonatur = payload => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
    .createImportDonatur(payload)
    .then(response => {
        dispatch(actions.donatursReload);
        return response.data;
    })
    .catch(error => {
        let err = error;
        if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
        }
        error = error.response.data.message;
        dispatch(
        actions.catchError({ error, callType: callTypes.action })
        );
        return err;
    });
};
